<!-- LottieAnimation.vue -->
<template>
  <DotLottieVue style="height: 500px; width: 500px" autoplay loop :src="animationPath" />
</template>

<script>

export default {
  name: 'LottieAnimation',
  props: {
    animationPath: {
      type: String,
      required: true
    }
  },
  mounted() {

  }
};
</script>

<style scoped>
</style>